<template>
  <div class="login-container">
    <div class="login-box">
      <!-- Left side: Image -->
      <div class="login-image">
        <img src="../assets/1.png" alt="Login illustration" />
      </div>

      <!-- Right side: Form -->
      <div class="login-form-wrapper">
        <h2 class="title">家属用电预付费</h2>
        <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" placeholder="请输入账号" prefix-icon="el-icon-user"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock"></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div class="captcha-wrapper">
              <el-input
                v-model="loginForm.code"
                placeholder="验证码"
                maxlength="4"
                @keyup.enter.native="submitForm('loginForm')"
              ></el-input>
              <img :src="captchaImg" class="captcha-img" @click="getCaptcha" alt="Captcha"/>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="login-button" @click="submitForm('loginForm')">
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs';

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        code: '',
        token: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      captchaImg: null
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post('/login?' + qs.stringify(this.loginForm)).then(res => {
            const jwt = res.headers['authorization'];
            this.$store.commit('SET_TOKEN', jwt);
            this.$router.push("/index");
          });
        } else {
          return false;
        }
      });
    },
    getCaptcha() {
      this.$axios.get('/captcha').then(res => {
        this.loginForm.token = res.data.data.token;
        this.captchaImg = res.data.data.captchaImg;
        this.loginForm.code = '';
      });
    }
  },
  created() {
    this.getCaptcha();
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background: url("../assets/login-bg.jpg") no-repeat center center;
  background-size: cover;
}

.login-box {
  display: flex;
  width: 70%;
  max-width: 1000px;
  height: 500px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.login-image {
  width: 50%;
  background-color: #f0f2f5; /* A light background for the image */
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-image img {
  max-width: 100%;
  height: auto;
  object-fit: cover;
}

.login-form-wrapper {
  width: 50%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title {
  font-size: 28px;
  color: #333;
  text-align: center;
  margin-bottom: 30px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.login-form {
  width: 100%;
}

.captcha-wrapper {
  display: flex;
  align-items: center;
}

.captcha-img {
  width: 110px;
  height: 40px;
  margin-left: 10px;
  cursor: pointer;
  border-radius: 4px;
}

.login-button {
  width: 100%;
  font-size: 16px;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .login-box {
    flex-direction: column;
    width: 90%;
    height: auto;
    max-width: 400px;
  }

  .login-image {
    display: none; /* Hide image on small screens to save space */
  }

  .login-form-wrapper {
    width: 100%;
    padding: 30px;
  }

  .title {
    font-size: 24px;
    margin-bottom: 20px;
  }
}
</style>